import { IEmailFamily } from "./email-family";

export interface IEmailFamilyListResponse {
    data: {
        success: boolean;
        message: string;
        results: IEmailFamily[]
    }
}
